/// <amd-module name="TFS/Admin/Groups/Pivots/Groups/Components/GroupsPivot" />
import * as React from "react";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { IPivotProps } from "TFS/Admin/Groups/Common/Contracts";
import { ConnectedGroupsPivotInitializer } from "TFS/Admin/Groups/Pivots/Groups/Components/GroupsPivotInitializer";

export class GroupsPivot extends VssComponent<IPivotProps> {
    constructor(props: IPivotProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element {
        return <ConnectedGroupsPivotInitializer filter={this.props.filter} pageContext={this.context.pageContext} />;
    }
}

VssComponent.register("ms.vss-admin-web.orggroups-group-pivot", GroupsPivot);
